import React from "react";
import DetailTable from "../component/DetailTable";
import Nav from "../component/Nav";
import Contact from "../component/Contact";
import Footer from "../component/Footer";
import Pdf from "../Uifiles/taproDev.pdf";
import SignleProjectDiscription from "../component/SignleProjectDiscription"

export default function Taprodev() {
  return (
    <div className="container-fluid">
      <div className="row">
        <Nav />

        <div className="col-10 offset-1">
          <div className="row">
            
            <SignleProjectDiscription
            type = "WEB PORTFOLIO"
            name = "TaproDev"
            dis1= "The TaproDev is our official web site."
            dis2= "Taprodev is a website that has been developed using ReactJS, a popular front-end JavaScript library for building user interfaces. ReactJS allows for the creation of reusable UI components that can be easily integrated into a single-page application. This means that Taprodev likely has a modern, responsive design that is optimized for speed and user experience. ReactJS is also known for its efficient rendering capabilities, making it a good choice for large, complex web applications that require fast performance. Overall, Taprodev is likely to be a well-designed and functional website built on a powerful technology stack."
            youtube = "https://www.youtube.com/embed/8wh-IIW8RlY"
            />

            

      
            <DetailTable
              link="https://www.taprodev.com"
              doc=""
              ui={Pdf}
              special="No Special note"
            />
          </div>
        </div>

        <Contact />
        <Footer />
      </div>
    </div>
  );
}
